import React from 'react';

import { OrdersOverviewCard } from '../orders-overview-card';
import { useOrdersOverview } from '../orders-overview-context/OrdersOverviewProvider';

export default function TotalSalesOverview() {
  const { trend, trendLastPeriod, totalAmount, totalAmountLastPeriod } =
    useOrdersOverview();

  if (!totalAmount && !totalAmountLastPeriod) {
    return null;
  }

  return (
    <OrdersOverviewCard
      amount={totalAmount}
      amountLastPeriod={totalAmountLastPeriod}
      amountType="currency"
      id="overview-total-sales"
      title="Total sales"
      trendData={trend.map((data) => data.total)}
      trendDataCompare={trendLastPeriod.map((data) => data.total)}
    />
  );
}
